<template>
    <z-basePage :title="'非工作日设置'" v-loading.fullscreen.lock="full_screenFlag">


        <div class="search-top">
            <span>年份</span>
            <div style="display:inline-block;position:relative">
                <el-input-number class="top-choose" v-model="year" @change="changeYear" :min="minYear"  :size="'small'"></el-input-number>
                <div class="mask" v-show="formObj.changeFlag" @click="saveCheck($event)"></div>
            </div>
            <span>快捷设置</span>
            <el-select class="top-choose" v-model="type" @change="changeType">
                <el-option v-for="item in typeArr" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
            </el-select>
            <span class="describe">
                <i></i>
                <span>非工作日</span>
                <span>单击日期设置非工作日</span>
            </span>
            <div class="back-btn blue" @click="save">保存</div>
        </div>

        <!-- 日历 -->
        <z-scrollDiv class="calendar-box">
            <div class="month-box" v-for="month in 12" :key="month">
				<div class="box-head">
					<div class="card">{{ (month+"").length==1?`0${month}`:month }}</div>
					<div>{{ monthStr[month-1] }}</div>
				</div>

                <div class="box-main">
                    <div class="top">
                        <span v-for="day in 7" :key="day">{{ weekStr[day-1] }}</span>
                    </div>
                    <div class="line" v-for="l in calcLines(month)" :key="l">
                        <span v-for="day in 7" :key="day" :class="{today:checkToday(month,l,day),choose:checkChoose(month,l,day),holiday:checkHoliday(month,l,day)}" @click="setHoliday(month,l,day)">{{ dateSet(month,l,day) }}</span>
                    </div>
                </div>
            </div>
        </z-scrollDiv>
        
        <!-- v-form 框 -->
        <div v-show="false" v-form="'back-holiday'">
            <input v-tar="holidayArr_str">
        </div>


    </z-basePage>
</template>

<script>
    export default {
        data(){
            return {
                full_screenFlag:false,  //全屏遮罩
                min:2018,  //前端默认最小年份
                // inputYear:this.min,  //input显示的年份
                year:this.min,  //年份  控制日历渲染
                type:"",   //快捷设置 双休/单休 控制节假日渲染
                data:{},  //获取的数据  
                formObj:{},  //表单对象 

                // *** 准备的一些固定数据
                monthStr:['January',"February",'March','April','May','June','July','August','Setpember','October','November','December'],
                weekStr:['一','二','三','四','五','六','日'],
                typeArr:[
                    {
                        value:1,
                        label:"双休",
                    },
                    {
                        value:2,
                        label:"单休",
                    },
                    {
                        value:3,
                        label:"周末无休",
                    },
                ],

   
            }
        },
        computed:{
            monthDays(){  //每月的数量数组
                let year = this.year;
                let d = year % 4 == 0 ? (year % 100 != 0 ? 1 : (year % 400 == 0 ? 1 : 0)) : 0;
                return [31,28+d,31,30,31,30,31,31,30,31,30,31]
            },
            firstDays(){  //每月第一天的星期 数组
                let res = [];
                let year = this.year;
                for(let i=0;i<12;i++){
                    res.push(new Date(year,i,1).getDay());
                }
                return res;
            },

            minYear(){  //最小年份
                return this.data.minYear || this.min;
            },
            today_arr(){  //当日 拆分数组
                let today = this.data.currentDate;
                return today?today.split("-").map(num=>parseInt(num)) : new Date().toLocaleDateString().split("/").map(num=>parseInt(num));
            },
            holidayArr(){  //节假日字符串数组
                return this.data.holidays || [];
            },
            holidayArr_str(){
                return this.holidayArr.join(",");
            },
            holidayObj(){  //节假日 分解对象
                let holiday = this.holidayArr;
                return holiday.sort().reduce((obj,date)=>{
                    let arr = date.split("-").map(num=>parseInt(num));
                    if(this.year != arr[0]){
                        return {};
                    }

                    obj[arr[1]] || (obj[arr[1]] = []);
                    obj[arr[1]].push(parseInt(arr[2]));
                    return obj;
                },{});
            },
        },
        watch:{
            // inputYear(newVal){
            //     this.type = "";
            // }
        },
        created(){
            this.refresh();
        },
        mounted(){
            this.formObj = this.$form.forms['back-holiday'];
        },
        methods:{
            refresh(year){  //获取节假日数据
                let url = `api/admin/cfg_holiday`;
                this.$http.get(url,{params:{year:year}}).then(res=>{
                    if(res.status == 200){
                        this.data = res.res_data;
                        console.log(this.data);
                        if(year == undefined){
                            this.year = this.today_arr[0];
                        }
                        this.$form.init('back-holiday');
                    }
                });
                // this.data = {
                //     currentDate:"2017-10-12",
                //     minYear:2016, 
                //     holiday:["2017-1-1","2017-3-3","2017-3-4","2017-5-1","2017-5-3","2017-7-6","2017-11-1","2017-11-11"]
                // }
                // let num = newYear || this.data.currentDate.split("-")[0] - 0;
                // this.year = num;
                // this.inputYear = this.year;
                // if(year == undefined){
                //     this.year = this.today.split("-")[0] - 0;
                // }
            },
            saveCheck(){   //遮罩点击事件
                this.errorTip("修改尚未保存");
            },
            changeYear:(function(){  //年份更改
                let timer;
                return function(newYear){
                    clearTimeout(timer);
                    this.type = "";  
                    timer = setTimeout(()=>{
                        this.refresh(newYear);
                    },300);
                }
            })(),
            changeType(val){  //快捷设置  双休/单休
                if(!val){
                    return;
                }
                // console.log(val);

                for(let month = 1;month<=12;month++){
                    for(let l = 1,len = this.calcLines(month);l<=len;l++){
                        for(let day = 1;day<=7;day++ ){

                            if(!this.checkChoose(month,l,day)){
                                continue;
                            }
                            let str = `${this.year}-${month}-${this.dateSet(month,l,day)}`;
                            let holidayArr = this.holidayArr;
                            let index = this.getIndex(str);
         

                            if(val === 1 && index == -1 && (day == 6 || day == 7) ){  //双休
                                holidayArr.push(str);
                            }else if(val === 2){  //单休
                                if(index != -1 && day == 6){
                                    holidayArr.splice(index,1);
                                }else if (index == -1 && day == 7){
                                    holidayArr.push(str);
                                }
                            }else if(val === 3 && index != -1 && (day == 6 || day == 7) ){  //周末无休
                                holidayArr.splice(index,1);
                            }

                        }
                    }
                }
            },
            setHoliday(month,l,day){  //点击设置节假日
                if(!this.checkChoose(month,l,day)){
                    return;
                }
                day = this.dateSet(month,l,day);
                let str = `${this.year}-${month}-${day}`;

                let holidayArr = this.holidayArr;
                let index = this.getIndex(str);
                // console.log(`obj Index : ${month}-${day}-(${index})`)
                if(index == -1){
                    holidayArr.push(str);
                }else{
                    holidayArr.splice(index,1);
                }

            },
            save(){  // 保存
                console.log("保存");
                this.full_screenFlag = true;
                let url = `api/admin/cfg_holiday`;
                this.$http.post(url,{
                    year:this.year,
                    holiday:this.holidayArr_str,
                }).then(res=>{
                    if(res.status == 200){
                        this.refresh(this.year);
                        this.successTip("非工作日设置成功");
                    }
                    this.full_screenFlag = false;
                }).catch(err=>{
                    this.errorTip("保存失败");
                    this.full_screenFlag = false;
                });
            },

            // ****样式判断

            checkToday(month,l,day){ //确认是否是当天
                let arr = this.today_arr;
                if(this.year == arr[0] && month == arr[1] && this.dateSet(month,l,day) == arr[2]){
                    return true
                }
                return false;
            },
            checkChoose(month,l,day){  //确认格子能否操作
                if( this.dateSet(month,l,day) == "" ){
                    return false;
                }
                let arr = this.today_arr;

                if(this.year > arr[0]){
                    return true;
                }else if(this.year == arr[0]){
                    if( month > arr[1]){
                        return true;
                    }else if(month == arr[1] && this.dateSet(month,l,day) > arr[2]){
                        return true;
                    }
                }
                return false;
            },
            checkHoliday(month,l,day){  //确认是否是节假日
                // if(this.year != this.inputYear){
                //     return false;
                // }

                let holidayObj = this.holidayObj;
                if(holidayObj[month] && holidayObj[month].indexOf(this.dateSet(month,l,day)) != -1 ){
                    return true;
                }
                return false;
            },


            // ***渲染相关
            calcLines(month){  //计算某月需要占用几行格子
                let index = month-1;
                let days = this.monthDays[index];
                let extra = this.getExtra(index);   //第一行需要放置的空格子数量
                return Math.ceil((extra + days)/7);
            },
            dateSet:(function(){  //填日期/获取日期
                let Year;
                let obj = {};
                return function(month,l,day){
                    if(this.year != Year ){
                        obj = {};
                        Year = this.year;
                    }

                    l = l - 1;
                    day = day - 1;
                    if(obj[month] && obj[month][l] && obj[month][l][day]!=undefined){
                        return obj[month][l][day];
                    }
                    let index = month - 1; 
                    let extra = this.getExtra(index); //第一行需要放置的空格子数量
       
                    let d = 7*l + day + 1;  //当前的格子位置
                    let num =  d - extra; 
                    let res = (num<1 || num>this.monthDays[index])?"":num;
                    obj[month] || (obj[month] = []);
                    obj[month][l] || (obj[month][l] = []);
                    obj[month][l][day] = res;

                    return res;
                }
            })(),
            getExtra(index){  //获取某月 第一行需要放置的空格子数
                if(isNaN(this.firstDays[index])){
                    return 0;
                }
                return this.firstDays[index] == 0?6:this.firstDays[index] - 1; 
            },
            getIndex(str){  // 获取str在时间数组中的位置
                let index = -1;
                let day_arr = str.split("-").map(num=>parseInt(num));
                this.holidayArr.some((str,i)=>{
                    let arr = str.split("-").map(num=>parseInt(num));
                    return arr[1] == day_arr[1] && arr[2] == day_arr[2] && (index = i);
                });
                return index;
            }


        },
        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-holiday',path:to.path});
			next(res);
		},
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";
    .calendar-box{
        height: calc(~"100% - @{line} - @{search_m} - 20px");
		margin-top: 20px;
        box-sizing: border-box;

		// width:calc(~"100% + @{basepage_padding}");
		// transform:translateX(-@basepage_padding);
		// .z-scroll-main{
		// 	padding-left: 20px;
    	// 	transform: translateX(-20px);
		// }
        &:after{
            content:"";
            display: block;
            clear:both;
        }

        
	}
	
	.z-z-scrollDiv .z-scroll-main{
		// width:calc(~"100% + 20px");
		
		padding-left: 20px;
    	transform: translateX(-20px);
	}

    .month-box{
        // position:relative;
        @box_w:200px;   //月份盒子总宽度
        @main_padd:10px;  //盒子主体部分左右padding
        @cage_w:18px;   //最小单位宽高
        @line_m:4px;    //行间距

        float: left;
		&:last-child{
			margin-bottom: 40px;
		}
        height: 200px;
        width:@box_w;
        margin-top: 20px;
        margin-right: 50px;
		box-sizing: border-box;
		padding-top:6px;
        background:#fff;
        box-shadow:0 1px 4px 0 rgba(184,184,184,0.5);
		
		// 头部
		.box-head{
			@h:35px;   //头部高度

			height:@h;
            line-height: @h;
			position: relative;
			box-sizing: border-box;
            padding-right: 10px;
            margin-bottom: 6px;
			text-align: right;
			font-size:24px;
			color:@blue;
			.card{
				width:60px;
				height:@h;
				color:#fff;
				font-size:16px;
				background:@blue;
				// background:linear-gradient(84deg,@blue,@blue 60px,#fff 60px);
                text-align:center;
				
				position: absolute;
				left: -10px;
                top:0;
                &:after{
                    content:"";
                    display: block;
                    width: 10px;
                    height: 100%;
                    position:absolute;
                    left: 100%;
                    top: 0;
                    background:@blue;
                    transform:skewX(-16deg);
                    transform-origin: left top;
                }
            }
            

        }

        // 主体
        .box-main{
            padding: 0 @main_padd;
            box-sizing: border-box;

           

            // 星期头部
            .top{
                font-size:12px;
                color:#2f2f2f;
            }   

            // 每行
            .line{
                margin-top:@line_m;
                font-size:12px;
                color:#cecece;
                // height:@cage_w;
            }

             // 每个方格
            span{
                height: @cage_w;
                line-height: @cage_w;
                width: @cage_w;
                display: inline-block;    
                text-align: center;
                // border:1px solid #333;
                box-sizing: border-box;
                vertical-align: bottom;
                transition: 0.3s;
                // cursor: not-allowed;
                user-select: none;
                &+span{
                    margin-left: (@box_w - @main_padd*2 - @cage_w*7)/6;
                }
            }
            

            // 各种状态
            .choose{
                cursor: pointer;
                color:#2f2f2f;
                &.holiday{
                    background:rgba(7,199,87,0.7);
                }
            }
            .holiday{
                border-radius: 50%;
                color:#fff;
                background:#cecece;        
            }
            .today{
                position: relative;
                &:after{
                    content:"";
                    display: block;
                    width:100%;
                    height:100%;
                    border-radius:50%;
                    box-sizing: content-box;
                    position:absolute;
                    top:-2px;
                    left: -2px;
                    border:2px solid #ff9393;
                }
            }

        }

    }

    // 计数器  重置样式
    .el-input-number span{
        height:calc(~"100% - 2px");
        line-height: 28px;
    }
    // 遮罩
    .mask{
        position: absolute;
        top: 0;
        left:0;
        height:100%;
        width: 100%;
        z-index:10;
    }


    //头部
    .search-top{

        //描述部分
        .describe{
            font-size: 12px;
            i{
                position: relative;
                display:inline-block;
                height: 10px;
                width: 10px;
                border-radius: 50%;
                margin-right: 3px;
                background:rgba(7,199,87,0.7);
            }
            >span:nth-of-type(2){
                color:#aaa;
            }
        }
    } 

    
</style>






// WEBPACK FOOTER //
// page-holiday.vue?05e0d806